<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id"
            >{{ label }}:
            <span class="text-red-500" v-if="isRequired">*</span></label
        >
        <select
            :id="id"
            ref="input"
            v-model="selected"
            v-bind="{ ...$attrs, class: null }"
            class="form-select ring-2 ring-gray-200"
            :class="{ error: error }"
        >
            <slot />
        </select>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import { v4 as uuid } from "uuid";

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `select-input-${uuid()}`;
            },
        },
        error: String,
        label: String,
        modelValue: [String, Number, Boolean],
        isRequired: {
            type: Boolean,
            default: true,
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            selected: this.modelValue,
        };
    },
    watch: {
        selected(selected) {
            this.$emit("update:modelValue", selected);
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        select() {
            this.$refs.input.select();
        },
    },
};
</script>
